export const navLinks = [
  { id: "hero", label: "首页" },
  { id: "how", label: "投稿教程" },
  { id: "format", label: "投稿格式" },
  { id: "topics", label: "投稿频道" },
  { id: "trending", label: "热门热议" },
  { id: "faq", label: "常见问题" },
];

export const steps = [
  {
    no: "01",
    title: "写好你的故事",
    desc: "想清楚要爆料的核心事件，把时间、人物关系、来龙去脉梳理清楚，用一段简洁的文字把前因后果说透，越具体越容易被采纳。",
    icon: "ri-pen-nib-line",
  },
  {
    no: "02",
    title: "配上证据图文",
    desc: "聊天记录截图、现场照片或视频都可以作为佐证。记得对无关人打码，保护隐私的同时也让内容更有说服力，图文并茂最受欢迎。",
    icon: "ri-image-add-line",
  },
  {
    no: "03",
    title: "提交等待审核",
    desc: "点击投稿入口，选择频道填好信息一键提交。吧友审核团会快速过审，高质量的内容会第一时间推荐到首页热榜。",
    icon: "ri-check-double-line",
  },
];

export const formatPoints = [
  {
    title: "标题党不如标题清",
    desc: "标题控制在 20 字内，一句话概括核心瓜点，别用夸张骗点击，清楚直白更易过审上热榜。",
    icon: "ri-edit-2-line",
  },
  {
    title: "正文三段式",
    desc: "背景铺垫 → 核心事件 → 个人看法，分点或分段写清楚，方便吃瓜群众快速 get 到重点。",
    icon: "ri-list-check-3",
  },
  {
    title: "证据图放在前面",
    desc: "最能说明问题的截图放第一张，并配上时间水印，图片清晰度会直接影响采纳率。",
    icon: "ri-image-line",
  },
  {
    title: "别写真人姓名",
    desc: "出于保护与合规，请用化名或首字母替代，避免引发不必要的纠纷，也是对自己的保护。",
    icon: "ri-user-heart-line",
  },
  {
    title: "话题标签更易火",
    desc: "带上相关话题标签，比如 #校园 #职场 #追星，系统会推送给对应频道的吃瓜用户。",
    icon: "ri-hashtag",
  },
  {
    title: "拒绝造谣与营销",
    desc: "主观猜测、无实锤抹黑与引流广告无法通过审核，请确保内容基于真实经历。",
    icon: "ri-shield-check-line",
  },
];

export const channels = [
  {
    name: "校园瓜",
    desc: "师生趣闻、宿舍八卦、社团内幕",
    icon: "ri-school-line",
    tag: "HIGH",
    count: "1.2k",
  },
  {
    name: "职场那些事",
    desc: "奇葩同事、裁员八卦、行业潜规则",
    icon: "ri-briefcase-4-line",
    tag: "HOT",
    count: "2.8k",
  },
  {
    name: "追星现场",
    desc: "饭圈动态、演唱会瓜、偶像塌房",
    icon: "ri-star-smile-line",
    tag: "NEW",
    count: "980",
  },
  {
    name: "邻里奇闻",
    desc: "小区怪事、奇葩邻居、物业纠纷",
    icon: "ri-home-smile-2-line",
    tag: "HOT",
    count: "3.5k",
  },
  {
    name: "恋爱八卦",
    desc: "相亲实录、情侣分合、前任考古",
    icon: "ri-heart-3-line",
    tag: "HIGH",
    count: "2.1k",
  },
  {
    name: "社会热闻",
    desc: "民生关注、奇人异事、热点评议",
    icon: "ri-fire-line",
    tag: "LIVE",
    count: "1.7k",
  },
];

export const trendingTabs = [
  {
    key: "today",
    label: "今日热榜",
  },
  {
    key: "week",
    label: "本周热议",
  },
  {
    key: "fresh",
    label: "新鲜投稿",
  },
];

export const trendingData: Record<string, { rank: string; title: string; meta: string; count: string }[]> = {
  today: [
    { rank: "1", title: "健身房教练私下对女学员说过的那些话，我来扒一扒", meta: "职场那些事 · 实锤图文", count: "2.4w" },
    { rank: "2", title: "室友凌晨打游戏外放，群聊记录让人血压拉满", meta: "校园瓜 · 聊天截图", count: "1.8w" },
    { rank: "3", title: "公司年会抽奖内幕，行政同事亲口说的黑幕", meta: "职场那些事 · 内幕", count: "1.5w" },
    { rank: "4", title: "某商场餐饮后厨卫生乱象，匿名校内同学投稿", meta: "社会热闻 · 现场", count: "1.2w" },
    { rank: "5", title: "相亲对象翻车实录：见面后才知道他早有对象", meta: "恋爱八卦 · 实录", count: "9800" },
    { rank: "6", title: "整栋楼都在追的那个神秘住户，到底什么来头", meta: "邻里奇闻 · 悬疑", count: "7600" },
  ],
  week: [
    { rank: "1", title: "知名网红带货翻车现场全程复盘，价格竟是三倍", meta: "追星现场 · 深扒", count: "6.3w" },
    { rank: "2", title: "考研自习室占座大战，监控截图流出", meta: "校园瓜 · 图文", count: "4.1w" },
    { rank: "3", title: "HR 面试潜规则合集，来自前员工爆料", meta: "职场那些事 · 内幕", count: "3.8w" },
    { rank: "4", title: "小区物业乱收费三年，业主集体维权全过程", meta: "邻里奇闻 · 维权", count: "2.9w" },
    { rank: "5", title: "追星女孩为了门票做出的事，看完沉默了", meta: "追星现场 · 见闻", count: "2.2w" },
    { rank: "6", title: "恋爱三年发现对方脚踏两条船，聊天记录曝光", meta: "恋爱八卦 · 实锤", count: "1.9w" },
  ],
  fresh: [
    { rank: "1", title: "刚入职一周就遇见办公室政治，求吧友支招", meta: "职场那些事 · 求助", count: "356" },
    { rank: "2", title: "学校食堂阿姨居然记得每个学生的口味，暖到了", meta: "校园瓜 · 温馨", count: "412" },
    { rank: "3", title: "楼下烧烤摊凌晨还在吵，打了三次电话没用", meta: "邻里奇闻 · 吐槽", count: "287" },
    { rank: "4", title: "游戏开黑遇到的神队友，语音里笑到岔气", meta: "恋爱八卦 · 日常", count: "198" },
    { rank: "5", title: "逛公园遇到大爷在下棋，旁边的小朋友好有梗", meta: "社会热闻 · 趣事", count: "165" },
    { rank: "6", title: "最新演唱会现场直击，这灯光绝了", meta: "追星现场 · 现场", count: "143" },
  ],
};

export const testimonials = [
  {
    quote: "第一次匿名投稿就被顶上了热榜，评论区吃瓜群众的分析比我自己还专业，太有成就感了。",
    name: "匿名小鱼",
    role: "职场频道活跃吧友",
    tag: "已过审",
  },
  {
    quote: "投稿流程真的很简单，图文格式讲得清清楚楚，十分钟就搞定了，第二天瓜就火了。",
    name: "爱凑热闹的桃",
    role: "恋爱八卦投稿人",
    tag: "上热榜",
  },
  {
    quote: "审核速度比我预想的快多了，还会提示怎么补充证据更清晰，很贴心的一个社区。",
    name: "瓜田守护者",
    role: "邻里频道吧友",
    tag: "已采纳",
  },
];

export const faqs = [
  {
    q: "投稿是匿名的吗？我的真实信息会被公开吗？",
    a: "是的，投稿默认完全匿名。我们不会在投稿内容中展示你的任何账号或联系方式，吧友只会看到你设置的昵称。请勿在正文或图片中主动暴露自己或他人的真实身份信息。",
  },
  {
    q: "投稿入口在哪里？多久能审核通过？",
    a: "点击页面顶部或底部的「投稿入口」，或在各频道卡片上点击「去投稿」即可进入投稿页。提交后通常会在 1-2 小时内完成审核，热门内容会优先推荐至首页热榜。",
  },
  {
    q: "支持图片和视频投稿吗？格式有什么要求？",
    a: "支持图文混排投稿，单条内容最多可上传 9 张图片，支持 jpg、png、gif 格式，建议单图不超过 5MB。暂时不支持直接上传视频，可将视频截图或转成动图后投稿。",
  },
  {
    q: "什么样的内容更容易过审并登上热榜？",
    a: "基于真实经历、有时间地点人物等细节、配图清晰且已对无关人打码的内容最受欢迎。避免造谣、人身攻击、营销引流和违反平台规范的敏感内容。",
  },
  {
    q: "投稿后可以修改或删除吗？",
    a: "投稿后 10 分钟内可自行编辑修改；如需删除，可在通过后联系吧务说明原因，经核实后我们会协助处理。审核通过后的热门内容删除会相对谨慎，以维护讨论秩序。",
  },
  {
    q: "发现投稿内容有虚假或侵权情况怎么办？",
    a: "如果你发现某条投稿涉及造谣、隐私侵犯或侵权内容，可通过页脚联系方式或投稿页的「投诉举报」通道反馈，吧务会在 24 小时内核实并处理。",
  },
];